import { Component, OnInit, Input, Pipe, ViewChild, forwardRef } from '@angular/core';
import { ModalService, DriverService, CommonService, CarrierService } from './../../../services/index';
import { Driver } from './../../../models/driver';
import { ActivatedRoute } from '@angular/router';

import { DriverFormComponent } from '../../../shared/driverform/driverform.component';

import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from './../../../../environments/environment';

import * as $ from 'jquery';
import * as _ from 'lodash';
import { AuthHelper } from '../../../shared/auth-helper';

@Component({
  selector: 'app-database',
  templateUrl: './database.component.html',
  styleUrls: ['./database.component.css'],
})
export class DatabaseComponent implements OnInit {
  modalId: string;
  carrierId: number;
  carrierName: string;
  allow_delete = environment.allow_delete;

  public CommonService = CommonService;

  @ViewChild(forwardRef(() => DriverFormComponent))
  private driverFormComponent: DriverFormComponent;

  columns = [
    {field: 'Action', text: 'Action'},
    {field: 'Identifier', text: 'Unique Identification', filterMatchMode: 'contains'},
    {field: 'FirstName', text: 'First Name', filterMatchMode: 'contains'},
    {field: 'LastName', text: 'Last Name', filterMatchMode: 'contains'},
    {field: 'Email', text: 'Email', filterMatchMode: 'contains'},
    {field: 'LicenceNumber', text: 'Licence #', filterMatchMode: 'contains'},
    {field: 'LicenceState', text: 'Licence State', filterMatchMode: 'contains'},
    {field: 'PhoneNumber', text: 'Tel. Number', filterMatchMode: 'contains'},
    {field: 'Status', text: 'Status', filterMatchMode: 'equals'},
  ];

  allowFilter = false;
  sortBy = 'FirstName';
  sortOrder = 'asc';

  drivers: Driver[] = [];
  driversFilteredList: Driver[] = [];

  hasChildern: Boolean;
  isLoading: Boolean;
  role: string;
  isAdmin: Boolean;

  constructor(
      private driverService: DriverService,
      private carrierService: CarrierService,
      private notificationService: NotificationsService,
      private modalService: ModalService,
      private route: ActivatedRoute,
      private spinner: NgxSpinnerService,
      ) {
    }

  ngOnInit() {
    this.modalId = 'driver-Modal';
    this.hasChildern = false;
    this.route.params.subscribe(params => {
      this.carrierId =  params['carrierId'];
    });
    this.loadData();

    this.isAdmin = AuthHelper.IsAdmin();
   }

  loadData() {
    const self = this;
    this.isLoading = true;
    let service: any;

    if (this.carrierId == 0) {
      this.driverService.getDrivers().subscribe(drivers => {
        self.drivers = _.orderBy(drivers, this.sortBy, [this.sortOrder]);
        self.drivers.forEach(item => {
          if (item.IsDeleted) {
            item.Status = "Disabled";
          }
          else if (item.ActivatedDateTimeUtc == null) {
            item.Status = "Inactive";
          }
          else {
            item.Status = "Active";
          }
        });
        self.driversFilteredList = self.drivers;
        this.isLoading = false;
      });
    }
    else
    {
      this.driverService.getDriversByCarrier(this.carrierId).subscribe(drivers => {
        self.drivers = _.orderBy(drivers, this.sortBy, [this.sortOrder]);
        self.driversFilteredList = self.drivers;
        this.isLoading = false;
      });

      this.carrierService.getCarrierInfo(this.carrierId).subscribe(info => {
        self.carrierName = info.Name;
      })
    }
  }

  openModal(id: number) {
    this.driverFormComponent.onLoad();
    this.driverFormComponent.loadForm();
    if (id > 0) {
      this.driverService.getDriver(id).subscribe(
        driver => {
          this.driverFormComponent.AssignDriver(driver) ;
        },
        error => {
          this.notificationService.error('Error', error);
        }
      );
    }

    this.modalService.open(this.modalId);

    if (!(id > 0)) {
      this.driverFormComponent.showForm() ;
    }
  }

  closeModal() {
    this.driverFormComponent.closeModal();
  }

  OnDelete(driver: Driver) {
    var msg = "";
    if (this.allow_delete)
    {
      msg = 'Are you sure you want to delete ' + driver.FullName + ' (' + driver.UserName + ')?\n\nTheir account and any ewd data will be deleted permanently!';
    }
    else
    {
      msg = 'Are you sure you want to disable ' + driver.FullName + ' (' + driver.UserName + ')?'
    }

    if (confirm(msg)) {
      const index = this.drivers.indexOf(driver);

      this.driverService.deleteDriver(driver.Id)
        .subscribe(
          result => {
            if (this.allow_delete) {
              this.notificationService.success('Success', 'Driver has been deleted');
            }
            else {
              this.notificationService.success('Success', 'Driver has been disabled');
            }
            this.loadData();
          }
        ,
        error => {
          this.notificationService.error('Error', error);
          // Revert the view back to its original state
        });
    }
  };

  filterOnClick() {
    this.allowFilter = this.allowFilter ? false : true;
  }
}
